import React from 'react';
import StopsCardsContent from './StopsCardsContent';
import InfoContent from './InfoContent';
import DesktopSearchPlaceContent from './SearchPlaceContent';
import DesktopDropAPinContent from './DropAPinContent';
import { useRecoilValue } from 'recoil';
import { atom_modalType } from '@app/shared/state/show-content-modal.atom';
import LinksContent from './LinksContent';
import PurchaseModalContent from './PurchaseModalContent';
import { DesktopCTAContent } from './DesktopCTAContent';
import AccessibilityModalContent from './AccessibilityModalContent';
import { useRenderTracker } from '@app/shared/debug';



const DefaultContent = () => (
    <div>
        {/* Hidden fallback button to ensure at least one tabbable node for focus-trap */}
        <button style={{ display: 'none' }} tabIndex={0}>Hidden Fallback</button>
    </div>
);

export function renderModalContent() {
    useRenderTracker('ModalContentRenderer');
    const atom_showedModalType = useRecoilValue(atom_modalType);
    switch (atom_showedModalType) {
        case 'stopsCards':
            return <StopsCardsContent />;
        case 'info':
            return <InfoContent />;
        case 'linksModal':
            return <LinksContent />;
        case 'searchPlace':
            return <DesktopDropAPinContent />;
        case 'dropAPin':
            return <DesktopDropAPinContent />;
        case 'desktopCTA':
            return <DesktopCTAContent />;
        case 'accessibility':
            return <AccessibilityModalContent />;
        case 'purchaseModalFromDemo':
            return <PurchaseModalContent />;
        case 'purchaseModalFromStop':
        default:
            return <DefaultContent />;
    }
}
